import React from 'react';
import TarjetaOpcion from './TarjetaOpcion';
import CampoTexto from './CampoTexto';
import PasoBordado from './PasoBordado';

export default function PasoGrupo({ grupo, valor, onCambiar, contexto }) {
  const elegidas = valor?.opcion_ids || [];
  const alternar = (id) => {
    if (grupo.tipo === 'unica') { onCambiar({ opcion_ids: elegidas.includes(id) && !grupo.obligatorio ? [] : [id], texto: '' }); return; }
    onCambiar({ opcion_ids: elegidas.includes(id) ? elegidas.filter(x => x !== id) : [...elegidas, id], texto: '' });
  };
  const indicacion = grupo.tipo === 'texto' ? 'Escribe tu texto' : grupo.tipo === 'multiple' ? 'Puedes elegir varias opciones' : 'Elige una opción';

  const cuerpo = () => {
    if (grupo.tipo === 'texto' && grupo.bordado) return <PasoBordado grupo={grupo} valor={valor} onCambiar={onCambiar} contexto={contexto} />;
    if (grupo.tipo === 'texto') return <CampoTexto grupo={grupo} valor={valor} onCambiar={onCambiar} />;
    return (
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        {grupo.opciones.map(o => <TarjetaOpcion key={o.id} opcion={o} elegida={elegidas.includes(o.id)} onElegir={() => alternar(o.id)} />)}
      </div>
    );
  };

  return (
    <div className="space-y-4" data-testid={`paso-grupo-${grupo.id}`}>
      <div>
        <h3 className="text-lg font-medium text-white">
          {grupo.nombre} {!grupo.obligatorio && <span className="text-sm font-normal text-zinc-500">(opcional)</span>}
        </h3>
        <p className="text-sm text-zinc-400">{grupo.ayuda || indicacion}</p>
      </div>
      {cuerpo()}
    </div>
  );
}
